export const MESSAGES_CLEAR_ALERTS = "MESSAGES_CLEAR_ALERTS";

export const MESSAGES_ADD_ALERT = "MESSAGES_ADD_ALERT";
export const MESSAGES_REMOVE_ALERT = "MESSAGES_REMOVE_ALERT";

export const MESSAGES_REMOVE_MESSAGE = "MESSAGESS_REMOVE_MESSAGE";
export const MESSAGES_ADD_ADHOC = "MESSAGES_ADD_ADHOC";
